/** Параметры из hash: #reset_token=… или #/reset-password?reset_token=… */
export function parseHashQueryParams(hash: string = window.location.hash): Record<string, string> {
  const raw = hash.replace(/^#/, '');
  const queryStart = raw.indexOf('?');
  const query = queryStart >= 0 ? raw.slice(queryStart + 1) : raw;

  return query.split('&').reduce((acc, pair) => {
    const [k, v] = pair.split('=');
    if (k) acc[decodeURIComponent(k)] = decodeURIComponent((v || '').replace(/\+/g, ' '));
    return acc;
  }, {} as Record<string, string>);
}
